/**
 * Melbourne Clock — Alpine.data() component
 *
 * Server renders initial time (h:mm AM/PM). Alpine enhances with
 * seconds and updates live every second.
 *
 * Reads timezone from data-timezone attribute on the element.
 * Falls back to Australia/Melbourne if not set.
 *
 * Usage:
 *   <span x-data="melbourneClock" data-timezone="Australia/Melbourne" x-text="time">
 *       {{ now format="g:i A" timezone="Australia/Melbourne" }}
 *   </span>
 */
export default function melbourneClock() {
    return {
        time: '',
        interval: null,

        init() {
            const tz = this.$el.dataset.timezone || 'Australia/Melbourne';
            const formatter = new Intl.DateTimeFormat('en-AU', {
                timeZone: tz,
                hour: 'numeric',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
            });

            this.time = formatter.format(new Date());
            this.interval = setInterval(() => {
                this.time = formatter.format(new Date());
            }, 1000);
        },

        destroy() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        },
    };
}
